import axios from 'axios'
import { Loading } from 'element-ui'

const service = axios.create()

// 响应拦截器
service.interceptors.response.use(
  // http请求成功的响应拦截
  response => {
    const res = response.data

    if (res.code == 200) {
      return res
    }

    response.message = res.msg || '数据请求错误'
    return Promise.reject(response)
  },

  // http请求失败的响应拦截
  error => {
    const { code, message, response = {} } = error

    if (response.data && response.data instanceof Object) {
      response.message =
        response.data.message || response.data.msg || '数据请求错误'
    } else {
      response.message = '数据请求错误'
    }

    if (code === 'ECONNABORTED' || message === 'Network Error') {
      response.message = '网络错误'
    }

    return Promise.reject(response)
  }
)

// 模块全局变量，loading计数器，实现多个接口请求，最后一个接口返回后才loading消失
let loadingNum = 0
let loadingInstance = null

/**
 * 对定义的axios进行再一次的封装，实现表单数据形式请求，loading和请求错误提示
 *
 * @param {Object} ajax  接口请求的配置参数
 * @param {Boolean} needLoading  是否需要全局的loading
 * @returns {Promise<void>}   返回promise的axios实例
 */
export default function(ajax, needLoading = true) {
  // 需要全局loading时的计数
  if (needLoading) {
    loadingNum++

    loadingInstance = Loading.service({
      fullscreen: true,
      body: true,
      customClass: 'z-index-loading',
      text: '正在加载，请稍后'
    })
  }

  return service(ajax).finally(() => {
    // loading消失的处理
    if (needLoading) {
      loadingNum--
      setTimeout(() => {
        if (loadingNum <= 0 && loadingInstance) loadingInstance.close()
      }, 0)
    }
  })
}
